import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import {
  Box,
  Avatar,
  Container,
  Button,
  Card,
  CardContent,
  Divider,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Typography
} from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { makeStyles } from '@material-ui/styles';
import {
  Link as RouterLink,
  useParams,
  useNavigate,
  Link
} from 'react-router-dom';
import { useGet } from '../../API/request';
import '../../styles/All.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { BallTriangle } from 'react-loader-spinner';
import { apiUrl } from '../../API/environment';

const UserInfo = () => {
  const navigate = useNavigate();
  const getU = useGet();
  const { id } = useParams();

  const [isLoaded, setIsLoaded] = useState(true);

  const [user, setUser] = useState({});

  useEffect(() => {
    setIsLoaded(true);
    getU(`admin/users/${id}`)
      .then((resp) => {
        if (resp.status === 'success') {
          setUser(resp.data.user);
        }
      })
      .catch(() => {})
      .finally(() => {
        setIsLoaded(false);
      });
  }, []);

  if (isLoaded) {
    return (
      <div className="loader">
        <BallTriangle
          height="100"
          width="100"
          color="grey"
          ariaLabel="loading"
        />
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Пользователи</title>
      </Helmet>
      <Box className="headerWrapper">
        <Box className="headerTitle">
          <Button startIcon={<ChevronLeft />} onClick={() => navigate(-1)}>
            Назад
          </Button>
          Пользователи
        </Box>
        <ul className="headerList">
          <li onClick={() => navigate(-1)}>Пользователи</li>
          <li>/</li>
          <li>Информация</li>
        </ul>
      </Box>

      <Box sx={{ backgroundColor: 'background.default', pt: 3, pb: 1 }}>
        <Container maxWidth={false}>
          <Card>
            <CardContent sx={{ p: 3 }}>
              <PerfectScrollbar>
                <div className="wrapAvatar">
                  <div className="avatar-block">
                    <Avatar
                      src={`${process.env.REACT_APP_API_URL}/uploads/avatars/${user.avatar}`}
                      className="avatar"
                    />
                  </div>
                  <div className="info-block">
                    <div className="wrap">
                      <div className="label">ID:</div>
                      <div className="text">{user?.id || '---'}</div>
                    </div>
                    <div className="wrap">
                      <div className="label">Имя</div>
                      <div className="text">{user?.name || '---'}</div>
                    </div>

                    <div className="wrap">
                      <div className="label">Email:</div>
                      <div className="text">{user?.email || '---'}</div>
                    </div>
                    <div className="wrap">
                      <div className="label">Номер телефона:</div>
                      <div className="text">{user?.phone || '---'}</div>
                    </div>

                    <div className="wrap">
                      <div className="label">Компания:</div>
                      <div className="text">
                        {user?.company?.name ? (
                          <Link
                            to={`/app/company/info/${user.company.id}`}
                            target="_blank"
                          >
                            {user?.company?.name}
                          </Link>
                        ) : (
                          '---'
                        )}
                      </div>
                    </div>

                    <div className="wrap">
                      <div className="label">Роль:</div>
                      <div className="text">{user?.role || '---'}</div>
                    </div>

                    <Box
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: 20,
                        marginLeft: 10
                      }}
                    >
                      <a
                        href={user?.companyId ?`${apiUrl}/api/probes/xlsx?companyId=${user?.companyId}` : `${apiUrl}/api/probes/xlsx?userId=${user?.id}`}
                      >
                        <Button color="primary" variant="contained">
                          Выгрузка проб
                        </Button>
                      </a>
                    </Box>
                  </div>
                  
                </div>
              </PerfectScrollbar>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </>
  );
};

export default UserInfo;
